export default __webpack_public_path__ + "static/media/monitor-tv-svgrepo-com.a501d685.svg";